import { getCurrentPageNameFromCookie } from './analytics.util';

type AnalyticsPageNameParams = {
  pathname: string;
  locale?: string;
  isNative?: boolean;
  segments?: string[];
};

export enum AnalyticsPageName {
  SEARCH_START = 'searchStart',
  SEARCH = 'search',
  AUTOCOMPLETE = 'autoCompletePage',
}

export enum AnalyticsSourceEvent {
  PDP_BOUGHT_TOGETHER = 'pdpboughtTogetherCarousel',
  PLP_BOUGHT_TOGETHER = 'pLpboughtTogetherCarousel',
  AUTOCOMPLETE_CAROUSEL = 'search',
  PLP_ADS_CAROUSEL = 'plpAdsCarousel',
  PLP_ADS_CAROUSEL_2 = 'plpAdsCarousel2',
}

const ROUTE_PATHS = {
  PLP_PAGE: '/s',
  SEARCH_START: '/searchStart',
} as const;

const stripLocale = (pathOnly: string, locale?: string): string => {
  if (!locale) return pathOnly;
  const prefix = `/${locale}`;
  return pathOnly.startsWith(prefix)
    ? pathOnly.slice(prefix.length) || '/'
    : pathOnly;
};

const getLocaleFromSegments = (segments: string[], locale?: string) => {
  if (locale) return locale;
  const first = segments[0];
  return first && /^[a-z]{2}$/i.test(first) ? first : undefined;
};

export const getPageNameFromPath = ({
  pathname,
  locale: localeOverride,
  segments,
}: AnalyticsPageNameParams): string => {
  const pageName = getCurrentPageNameFromCookie() 
  if (pageName) return pageName;
  const pathOnly = (pathname ?? '').split('?')[0] || '/';
  const partsFromPathname = pathOnly.split('/').filter(Boolean);
  const locale = getLocaleFromSegments(
    segments ?? partsFromPathname,
    localeOverride
  );

  const withoutLocale = stripLocale(pathOnly, locale);
  const normalized = withoutLocale.startsWith('/')
    ? withoutLocale
    : `/${withoutLocale}`;

  if (segments && segments.length > 0) {
    const cleaned = segments.filter(Boolean);
    const cleanedWithoutLocale =
      locale && cleaned[0] === locale ? cleaned.slice(1) : cleaned;
    const pageSegment = cleanedWithoutLocale[0];

    if (pageSegment === 's') return AnalyticsPageName.SEARCH;
    if (pageSegment === 'searchStart') return AnalyticsPageName.SEARCH_START;
  }

  if (
    normalized === ROUTE_PATHS.PLP_PAGE ||
    normalized.startsWith(`${ROUTE_PATHS.PLP_PAGE}/`)
  )
    return AnalyticsPageName.SEARCH;
  if (
    normalized === ROUTE_PATHS.SEARCH_START ||
    normalized.startsWith(`${ROUTE_PATHS.SEARCH_START}/`)
  )
    return AnalyticsPageName.SEARCH_START;

  return AnalyticsPageName.SEARCH_START;
};
